module.exports = __webpack_public_path__ + "images/file_icons_v2/wma-d7f43b4cd7d4edd1ded0bc6cc3c3e135.svg";